<template>
  <div id="my-node" class="Portrait" :class="{ 'is-tablet': $root.$agent.tablet == true, 'is-ipad': $root.$agent.ios == 'iPad', 'artwork': $route.meta.name == 'artwork' }">
    <div class="Portrait__container" :class="{ 'is-right': is_right }">  
      <div ref="backgrounds" class="Portrait__asset"><img :src="require('../img/backgrounds/thumbnail/'+ assets.backgrounds +'.png')"v-if="assets.backgrounds"/></div> 
      <div ref="silhouettes" class="Portrait__asset"><Silhouettes/></div> 
      <div ref="clothing" class="Portrait__asset"><img :src="require('../img/clothing/large/'+ assets.clothing +'.png')"v-if="assets.clothing"/></div>
      <div ref="eyes" class="Portrait__asset"><Eyes/></div>
      <div ref="eyebrows" class="Portrait__asset"><Eyebrows/></div>
      <div ref="hair" class="Portrait__asset"><Hair/></div> 
      <div ref="noses" class="Portrait__asset"><Noses/></div> 
      <div ref="mouths" class="Portrait__asset"><Mouths/></div>  
      <div ref="accessories" class="Portrait__asset" style="left: 8px;"><img :src="require('../img/accessories/thumbnail/'+ assets.accessories +'.png')"v-if="assets.accessories"/></div> 
      <div ref="other" class="Portrait__asset" style="left: 8px;"><img :src="require('../img/accessories/thumbnail/'+ assets.other +'.png')"v-if="assets.other"/></div> 
      <div ref="texture" class="Portrait__asset">
        <img :src="require('../img/assets/texture.png')"/>
      </div> 
      <div class="Portrait__download" :class="'is-'+ lang" @click="download()" v-if="$route.meta.name == 'artwork' && !downloaded && $root.$agent.tablet == null"> 
        <img :src="require('../img/assets/download.png')"/>
        <div class="Portrait__txt">{{ trans('download') }}</div>
      </div>
    </div>
    <transition name="Portrait__icons">
      <div class="Portrait__icons" v-if="slugIsIn('defi3')">
        <div clkass="Portrait__icon"><img :src="require('../img/assets/close.png')" @click="erase()"/></div>
        <div clkass="Portrait__icon"><img :src="require('../img/assets/undo.png')" @click="undo()"/></div>
      </div>
    </transition>
  </div>
</template>

<script>

import { Categories } from '../js/Categories.js'
import Silhouettes from '../svg/Silhouettes'
import Hair from '../svg/Hair'
import Eyes from '../svg/Eyes'
import Eyebrows from '../svg/Eyebrows'
import Noses from '../svg/Noses'
import Mouths from '../svg/Mouths'
import domtoimage from 'dom-to-image'

export default {
  name: 'Portrait',
  components: { Hair, Silhouettes, Eyes, Eyebrows, Mouths, Noses },
  data: ()=>({
    ready: false,
    is_right: false,
    downloaded: false,
    assets: {
      backgrounds: null,
      silhouettes: null, 
      hair: null, 
      mouths: null, 
      eyes: null, 
      eyebrows: null,  
      noses: null, 
      clothing: null, 
      accessories: null,  
      other: null,  
    }
  }),

  translations: {
    fr: {
      portrait: "mon-portrait",
      download: "Télécharger"
    },
    en: {
      portrait: "my-portrait",
      download: "Download"
    },
  },

  computed: {
    history() { return this.$store.getters['app/history'] },
    portrait() { return this.$store.getters['app/portrait'] },
    categorie() { return this.$store.getters['app/categorie'] },
    base_64() { return this.$store.getters['app/base_64'] },
  },
  watch: {

    '$route': {
      immediate: true,
      handler() {

        if(this.slugIsBefore('defi3')) 
          this.erase()

        if(this.slugIsIn(['defi3']))
          this.is_right = true
        else 
          this.is_right = false

        if(this.slugIsIn(['33']) 
        && this.portrait.backgrounds == null 
        && this.portrait.silhouettes == null 
        && this.portrait.hair == null 
        || this.$route.meta.name == 'artwork'
        && this.portrait.backgrounds == null 
        && this.portrait.silhouettes == null 
        && this.portrait.hair == null )
          this.$nextTick(()=>{
            this.setDefault()
          })
      }
    },
    'portrait': {
        immediate: true,
        deep: true,
        handler() {    
          this.$nextTick(()=>{

            _.each(this.portrait, (asset, target)=>{
              this.assets[target] = asset
              // console.log(this.assets);
            })
            if(this.categorie != "empty") {
              if(this.$tween) this.$tween.kill()
              this.$tween = new TimelineMax()
                  .set(this.$refs[this.categorie], { opacity: 0 })
                  .to(this.$refs[this.categorie], .5, { opacity: 1, delay: .5 })
            }
            TweenMax.to(this.$el, .5, { opacity: 1, ease: Linear.easeOut, delay: .5 })
          })
        }
    },
  },

  methods: {
    erase() {
      this.$store.commit('app/SET_AMBIANCE', 'click')
      this.$store.commit('app/ERASE')
    },
    undo() {
      this.$store.commit('app/SET_AMBIANCE', 'click')
      this.$store.commit('app/UNDO_HISTORY')
      const last = _.last(this.history)
      if(this.history.length > 0) {
        this.$store.commit('app/SET_CATEGORIE', last.categorie)
        this.$store.commit('app/SET_PORTRAIT', { categorie: last.categorie, value: last.value })
      }
      else 
        this.$store.commit('app/ERASE')
    },
    getExtension(val) {
      // console.log(val);
      // console.log(val == 'hair');
      return 'png'
    },
    setDefault() {
      this.$store.commit('app/SET_PORTRAIT', { categorie: Categories[0].id, value: _.sample(Categories[0].items) })
      this.$store.commit('app/SET_PORTRAIT', { categorie: Categories[1].id, value: _.sample(Categories[1].items) })
      this.$store.commit('app/SET_PORTRAIT', { categorie: Categories[6].id, value: _.sample(Categories[6].items) })
      this.$store.commit('app/SET_PORTRAIT', { categorie: Categories[7].id, value: _.sample(Categories[7].items) })
      this.$store.commit('app/SET_PORTRAIT', { categorie: Categories[8].id, value: _.sample(Categories[8].items) })

      TweenMax.delayedCall(1, ()=>{
        this.$parent.setBase64()
      }) 
    },
    download() {

      this.downloaded = true
      if(this.base_64) {
        let link = document.createElement('a')
            link.download = this.trans('portrait') +'.png'
            link.href = this.base_64
            link.click()
      } 
      else {
        domtoimage.toPng(document.getElementById('my-node'), { quality: 0.95 })
        .then( (dataUrl)=> {
          let img = new Image()
              img.src = dataUrl
          document.getElementById('capture').appendChild(img)
          TweenMax.delayedCall(.1, ()=>{
            domtoimage.toPng(document.getElementById('capture'), { quality: 0.95, width: 326, height: 435 })
            .then( (dataUrl)=> {
                var link = document.createElement('a')
                    link.download = this.trans('portrait') +'.png'
                    link.href = dataUrl
                    link.click()
            })
          })
        })
      }
    },
  },

}
</script>

<style lang="stylus">
@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.Portrait
  width 100vw
  height 100vh
  opacity 0
  pointer-events none

  &.artwork
    pointer-events auto

  &.is-ipad 
    top -30px
    position absolute
    transform scale(.8)

  &__container
    position relative
    top 50%
    left 50%
    transform translate(-50%, -50%)
    background black
    outline 2px solid white
    width 326px
    height 435px
    transition opacity .5s, transform .5s

    &.is-right 
      transform translate(calc((100vw - 660px) / 2 - ( (100vw - ( 1040px )) / 2 )), -50%)

      +max-screen-height(tablet-portrait)
        transform translate(calc((100vw - 660px) / 2 - ( (100vw - ( 924px )) / 2 )), -50%)

    

  &__asset 
    width 100%
    height 100%
    position absolute 
    top 0
    left 0

    & img 
      height 435px
    
  &__icons
    position absolute 
    top calc(50% - 180px)
    left 50%
    transform translate(calc((100vw - 660px) / 2 - ( (100vw - ( 1040px )) / 2 ) + 350px), -50%)
    cursor pointer
    transition opacity 1s, transform 1s
    transition-delay .5s

    +max-screen-height(tablet-portrait)
      transform translate(calc((100vw - 660px) / 2 - ( (100vw - ( 1040px )) / 2 ) + 280px), -50%)

    &-enter
      opacity 0

    &-leave-active
      transition-delay 0s
      transition opacity .25s
      opacity 0


  &__download
    position absolute

    top 460px
    left 50%
    transform translateX(-50%)
   
    cursor pointer
    background red
    width 174px
    height 42px
    border-radius 24px
    background white
    color black
    transition opacity 1s, transform .5s
    transition-delay 1s
    display flex
    align-items center
    justify-content space-between
    font-size 12px 
    text-transform uppercase
    letter-spacing 0.2em
    font-weight 700

    &.is-en
      width 160px

    & img 
      width 42px

  &__txt 
    padding 0 22px 0 0

</style>































































// WEBPACK FOOTER //
// src/components/defis/components/Portrait.vue